class OKMCampaigns {
  static memKey = 'okm_campaigns';
  static daysToExpire = 90;
  static paramMap = {
    'utm_source': 'u_so',
    'utm_medium': 'u_me',
    'utm_campaign': 'u_ca',
    'utm_term': 'u_te',
    'utm_content': 'u_co',
    'gclid': 'c_go',
    'fbclid': 'c_fa',
    'ttclid': 'c_ti'
  };

  static update() {
    let storedParams = {};
    let hasParams = false;
    const params = new URLSearchParams(window.location.search);

    const item = OKMCampaigns.read();
    if ( item && (Date.now() > item.expiry) ) { 
      localStorage.removeItem(this.memKey);
    }
  
    for (const [originalKey, storageKey] of Object.entries(this.paramMap)) {
      if (params.has(originalKey)) {
        const value = params.get(originalKey);
        if (value !== null && value.trim() !== '') {
          storedParams[storageKey] = value;
          hasParams = true;
        }
      }
    }
  
    if (hasParams) {
      const record = {
        data: storedParams,
        expiry: Date.now() + this.daysToExpire * 24 * 60 * 60 * 1000
      };
      localStorage.setItem(this.memKey, JSON.stringify(record));    
    }
  }

  static read() {
    const itemStr = localStorage.getItem(this.memKey);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);   
      const reverseMap = Object.fromEntries(
        Object.entries(this.paramMap).map(([original, alias]) => [alias, original])
      );

      const remappedData = {};
      for (const [aliasKey, value] of Object.entries(item.data)) {
        const originalKey = reverseMap[aliasKey] || aliasKey; // Fallback falls kein Mapping vorhanden
        remappedData[originalKey] = value;
      }
      return remappedData;
    } catch (e) {
      localStorage.removeItem(this.memKey);
      return null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  OKMCampaigns.update();
});